import { parse, theme } from "@config/theme";
import { CbTextText } from "@generated/models/CbTextText";
import { css } from "linaria";
import React, { FC } from "react";
import { Container, CONTENT_BLOCK_MB } from "../Container";
import { Heading } from "../typograhpy/Heading";
import { Text } from "../typograhpy/Text";
export const TextAndText: FC<CbTextText> = ({
  title,
  text
}) => {
  return <Container mb={CONTENT_BLOCK_MB}>
      <div className={container}>
        <div className={titleContainer}>
          <Heading variant="h2" as="h2">
            {title.value}
          </Heading>
        </div>
        <div className={contentContainer}>
          <Text>{text.value}</Text>
        </div>
      </div>
    </Container>;
};
const container = parse({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between"
}, "c1xzvpr5");
const titleContainer = parse({
  textAlign: {
    _: "left",
    medium: "right"
  }
}, "t14wd4tl");
const contentContainer = parse({}, "ckz4trj");

require("./TextAndText.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TextAndText.tsx");